// @flow
import React, { PureComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { loadBuildings } from '../../../libs/buildings';
import config from '../../../config';

const SliderSpace = styled.div`
  padding-top: calc(50vw - 194px);
  position: relative;
  z-index: -1;
`;

const appear = keyframes`
  from {
		top: -100%;
    transform: scale(1.3);
    opacity: 0;
	}

	to {
		top: 0;
    width: 100%;
    transform: scale(1);
    opacity: 1;
	}
`;

const SliderBar = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const SliderBarContainer = styled.div`
  background: rgba(0,0,0,0.7);
  position: absolute;
  width: 100%;
  bottom: 0;
`;

const CarouselItem = styled.div`
  background: url("${props => props.background}");
  display: ${props => props.isActive || props.isPrev ? 'flex' : 'none'};
  animation: ${appear} 1s;
  background-size: cover;
  background-position: 50%;
  width: 100%;
  height: 100%;
  position: absolute;
`;

const Slider = styled.div`
  display: flex;
  width: 100%;
  padding-top: 50vw;
  margin: auto;
  position: relative;
  overflow: hidden;
  position: absolute;
  top: 0;
`;

const SliderContent = styled.div`
  transition: transform 1s;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  touch-action: pan-x;

  &::-webkit-scrollbar { 
    display: none; 
  }
`;

const NavButton = styled.a`
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  width: 30px;
  height: 50px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  justify-content: center;
  align-items: center;
  border: 1px solid #333;
  display: none;
  cursor: pointer;

  ${Slider}:hover & {
    display: ${props => props.disabled ? 'none' : 'flex'};
  }
`;

const BackButton = NavButton.extend`
  left: 20px;
`;

const NextButton = NavButton.extend`
  right: 20px;
`;

const BarThubnail = styled.a`
  width: 130px;
  height: 130px;
  background: url("${props => props.background}");
  border: ${props => props.isActive ? '3px solid white' : 'none'};
  transition: border 0.2s;
  box-sizing: border-box;
  background-size: cover;
  background-position: 50%;
  cursor: pointer;
  margin: 0 5px;
`;

const KindOffer = styled.div`
  color: white;
  font-size: 20px;
  text-shadow: 1px 1px 1px #000;
  text-align: right;
`;

const Sector = styled.div`
  color: white;
  font-size: 14px;
  text-shadow: 1px 1px 1px #000;
`;

const CarouselInfo = styled.a`
  display: flex;
  position: absolute;
  bottom: 300px;
  flex-direction: column;
  max-width: 1024px;
  margin: auto;
  right: 0;
  text-align: right;
  text-decoration: none;
  bottom: 200px;
`;

const InfoContainer = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  width: 100%;
  position: relative;
`;
class FavoriteSlider extends PureComponent {
  state = {
    favorites: [],
    loading: true,
    current: 0,
  }

  componentDidMount() {
    if (this.props.clientInfo) {
      this.loadFavorites(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clientInfo !== nextProps.clientInfo) {
      this.loadFavorites(nextProps);
    }
  }

  loadFavorites = async (props) => {
    try {
      const data = await loadBuildings({
        includeAgentInfo: false,
        includeExpired: false,
        includeClientInfo: false,
        allimages: false,
        favorites: '1',
        id: props.clientInfo.clients_id,
      });
      this.initAnimation();
      this.setState({
        loading: false,
        favorites: data.model,
      });
    } catch(ex) {
      this.setState({
        loading: false,
        error: true,
      });
      console.error('Error al cargar favoritos', ex);
    }
  }

  initAnimation = () => {
    this.it = setInterval(() => {
      const limit = this.state.favorites.length;
      const next = this.state.current + 1;
      this.setState({
        current: next >= limit ? 0 : next,
      });
    }, 7000);
  }

  props: {
    clientInfo: Object,
  }

  goTo = (index) => {
    clearInterval(this.it);
    this.setState({
      current: index,
    });
    this.initAnimation();
  }

  render() {
    return (
      <div>
        <Slider>
          <SliderContent>
            {this.state.favorites.map((f, i) => (
              <CarouselItem
                key={f.id}
                background={`${config.photosHost}/${f.bInImages[0].image}`}
                isActive={this.state.current === i}
                isPrev={this.state.current === i + 1}
              >
                <InfoContainer>
                  <CarouselInfo href={`/${f.permalink}-${f.bCodes.building_code}.html`} target="_blank">
                    <KindOffer>{f.kindOffer.offer_reference_res} {f.kindBuilding.building_name} {f.area_m}{f.areaUm.metter_reference}</KindOffer>
                    <Sector>{f.city0.CityName} {f.sector0.sector_name}</Sector>
                  </CarouselInfo>
                </InfoContainer>
              </CarouselItem>
            ))}
          </SliderContent>
          <SliderBarContainer>
            <SliderBar>
              {this.state.favorites.map((f, i) => (
                <BarThubnail
                  onClick={() => {
                    this.goTo(i);
                  }}
                  key={f.id}
                  background={`${config.photosHost}/${f.bInImages[0].image}`}
                  isActive={this.state.current === i}
                />
              ))}
            </SliderBar>
          </SliderBarContainer>
        </Slider>
        <SliderSpace />
      </div>
    );
  }
}

export default connect(state => ({
  clientInfo: state.client.info, 
}))(FavoriteSlider);



// WEBPACK FOOTER //
// ./src/components/HomeLayout/FavoriteSlider/index.js